import React from 'react';

const Header = () => {
  return <div className='private_header d-flex flex-row-reverse'></div>;
};

export default Header;
